<template>
  <f7-page no-swipeback @page:afterin="fetchData">
    <f7-navbar title="訂單詳情 Order Info" back-link="返回 Back"></f7-navbar>

    <f7-list media-list>
      <f7-list-item
        title="狀態 STATUS"
        :subtitle="$f7route.query.status"
      ></f7-list-item>

      <f7-list-item
        title="日期範圍 DATE RANGE"
        :subtitle="`${fromDate} ${toDate}`"
      ></f7-list-item>

      <f7-list-item v-if="orders_data.total_quantity > 100">
        <f7-button popover-open=".popover-menu" raised @click="isOpened = true">列印 Print - 全部 All</f7-button>
      </f7-list-item>

      <f7-list-item v-else>
        <f7-button raised @click="() => print()">列印 Print - 全部 All</f7-button>
      </f7-list-item>

      <f7-list-item :key="category.id" v-for="category in categories" v-show="hasSubCategoriesData(category.id)">
        <f7-button raised @click="() => print(category.id)">列印 Print - {{ category.name }}</f7-button>
      </f7-list-item>

      <f7-popover class="popover-menu" :opened="isOpened">
        <f7-list>
          <f7-list-item title="打印數量超過100件，是否繼續打印？">
          </f7-list-item>
          <f7-list-item>
            <f7-button popover-close @click="() => print()" style="width: 100%">yes</f7-button>
          </f7-list-item>
          <f7-list-item>
            <f7-button @click="isOpened = false" style="width: 100%">no</f7-button>
          </f7-list-item>
        </f7-list>
      </f7-popover>

      <f7-list-group :key="category_index" v-for="(category, category_index) in categories_products">
        <f7-list-item :title="category.category_name" group-title></f7-list-item>
        <TotalListProduct
          v-for="(product, product_index) in category.products"
          :key="product_index"
          :name="product.name"
          :quantity="product.original_quantity"
          :supply-quantity="product.quantity"
          :price="`${product.price}`"
          :missing-product="missing_products"
        ></TotalListProduct>
      </f7-list-group>

      <f7-list-group v-if="missing_products.length > 0">
        <f7-list-item title="工場備註 Warehouse Remarks" group-title></f7-list-item>
        <f7-list-item v-for="product in missing_products" :key="product.id" :title="`${product.name} 欠Missing ${product.difference} 件Unit`"></f7-list-item>
      </f7-list-group>
    </f7-list>

    <f7-toolbar position="bottom" style="font-size: .875rem;">
      <div style="width: 65%;">
        <span v-if="orders_data.products">
          {{ orders_data.products.length }} 項 Items，
        </span>
        <div style="display: inline;">
          Supply 提供
          <span v-if="status && status === 'Completed'">{{ orders_data.completed_supply_total_quantity }}</span>
          <span v-else>{{ orders_data.uncompleted_supply_total_quantity }}</span>
          件 Unit，
        </div>
        <span>Sum 總數 {{ orders_data.total_quantity }} 件 Unit</span>
      </div>
      <div style="width: 35%;">
        Total 合計 ${{ displayTotal }}
      </div>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import axios from 'axios'
import { format, parseISO } from 'date-fns'

import TotalListProduct from './TotalListProduct.vue'

export default {
  components: {
    TotalListProduct
  },

  data() {
    return {
      orders_data:{},
      original_data: {},
      categories: [],
      categories_subcategories: [],
      categories_products: [],
      subcategory_ids: [],
      filters: [],
      status: this.$f7route.query.status,
      fromDate: format(parseISO(this.$f7route.query.fromDate), 'yyyy-MM-dd'),
      toDate: this.$f7route.query.fromDate === this.$f7route.query.toDate ? ' - ' + format(parseISO(this.$f7route.query.toDate), 'yyyy-MM-dd') : '',
      isOpened: false
    }
  },

  computed: {
    displayTotal() {
      if (!this.orders_data.total) {
        return 0;
      }
      
      const total = this.orders_data.total / 100;
      return Math.round(total * 10) / 10;
    },
    missing_products() {

      let missing_products = []

      for (let i = 0; i < this.categories_products.length; i++) {
        for (let j = 0; j < this.categories_products[i].products.length; j++) {
          let product = this.categories_products[i].products[j]

          if (product.original_quantity - (this.status === 'Completed' ? product.quantity.completed_supply_quantity : product.quantity.uncompleted_supply_quantity) !== 0) {
            missing_products.push({
              // id: product.id,
              name: product.name,
              category_id: this.categories_products[i].category_id,
              difference: product.original_quantity - (this.status === 'Completed' ? product.quantity.completed_supply_quantity : product.quantity.uncompleted_supply_quantity),
              supply_quantity: this.status === 'Completed' ? product.quantity.completed_supply_quantity : product.quantity.uncompleted_supply_quantity,
              supply_subtotal: (this.status === 'Completed' ? product.quantity.completed_supply_quantity : product.quantity.uncompleted_supply_quantity) * product.price,
            })
          }
        }
      }

      return missing_products
    }
  },

  methods: {
    fetchData () {
      axios.get('/api/categories').then(({ data }) => {
        this.categories = data

        this.categories_subcategories = this.categories.map((root_category) => {
          return {
            id: root_category.id,
            subcategories: root_category.subcategories.map((subcategory) => {
              return subcategory.id
            })
          }
        })
      })

      axios.post('/api/orders-summary', {
        filters: { fromDate: this.$f7route.query.fromDate, toDate: this.$f7route.query.toDate },
        status: this.$f7route.query.status
      })
        .then(({ data }) => {
          this.original_data = data

          let subCategories = [...new Set(data.products.map(product => product.category.id))];
          this.subcategory_ids = subCategories

          let structured = subCategories.map((category_id) => {
            let categoryFound = data.products.find(obj => obj.category.id === category_id)

            return {
              category_id: category_id,
              category_name: categoryFound.category.name,
              products: data.products.filter((item) => {
                return item.category.id === category_id
              }).map((product) => {
                return {
                  // id: product.id,
                  name: product.product_name,
                  subname: product.product_subname,
                  quantity: {
                    completed_supply_quantity: product.completed_supply_quantity,
                    completed_supply_subtotal: product.completed_supply_subtotal,
                    uncompleted_supply_quantity: product.uncompleted_supply_quantity,
                    uncompleted_supply_subtotal: product.uncompleted_supply_subtotal,
                  },
                  original_quantity: product.quantity,
                  price: (product.price / 100),
                  features: [] // product.properties
                }
              })
            }
          })

          this.categories_products = structured

          this.orders_data = data
        })

    },
    print(root_category_id) {
      if (typeof root_category_id !== 'undefined') {
        // 单个 category 打印
        let category_ids = this.categories_subcategories.find(root_category => root_category.id === root_category_id).subcategories || []

        let new_data = JSON.parse(JSON.stringify(this.original_data))

        let new_products = new_data.products
          .map(product => {
            product.subtotal = product.quantity * product.price

            return product
          })
          .filter(product => category_ids.includes(product.category_id))
        new_data.products = new_products

        new_data.total_quantity = new_products.reduce((res, product) => {
          return res += product.quantity
        }, 0)
        new_data.total = new_products.reduce((res, product) => {
          return res += product.price * product.quantity
        }, 0)

        new_data.supply_total = new_products.reduce((res, product) => {
          return res += product.price * (this.status === 'Completed' ? product.completed_supply_quantity : product.uncompleted_supply_quantity)
        }, 0)

        new_data.supply_total_quantity = new_products.reduce((res, product) => {
          return res += (this.status === 'Completed' ? product.completed_supply_quantity : product.uncompleted_supply_quantity)
        }, 0)

        new_data.id = '總單'

        new_data.store = {
          name: `${this.categories.find(category => category.id === root_category_id).name}\n日期範圍:${this.fromDate} - ${this.toDate}`
        }

        new_data.order_at = this.$f7route.query.fromDate

        new_data.created_at = this.$f7route.query.fromDate

        new_data.user = {
          name: '-'
        }

        new_data.status = this.$f7route.query.status

        window.ReactNativeWebView.postMessage(JSON.stringify(new_data))
      } else {
        // 全部 category 打印
        let new_data = JSON.parse(JSON.stringify(this.original_data))
        new_data.total_quantity = this.original_data.total_quantity
        new_data.total = this.original_data.total

        let new_products = new_data.products
          .map(product => {
            product.subtotal = product.quantity * product.price

            return product
          })

        new_data.products = new_products

        new_data.status = this.$f7route.query.status

        new_data.id = '總單'

        new_data.store = {
          name: `日期範圍:${this.fromDate} - ${this.toDate}`
        }

        new_data.order_at = this.$f7route.query.fromDate

        new_data.created_at = this.$f7route.query.fromDate

        new_data.user = {
          name: '-'
        }

        new_data.status = this.$f7route.query.status

        window.ReactNativeWebView.postMessage(JSON.stringify(new_data))
      }
    },
    hasSubCategoriesData(root_category_id) {
      let category_ids = this.categories_subcategories.find(root_category => root_category.id === root_category_id).subcategories || []

      return category_ids.filter(value => this.subcategory_ids.includes(value)).length > 0
    },
  }
}
</script>
